import React, { forwardRef, useRef } from 'react'
import PortalModal from '../../../../Common/Modal/PortalModal'
import { toast } from 'react-toastify'
import api from '../../../../../middleware/api'

const DeleteMultipleCustomersModal = forwardRef(({ users, updateTable }, ref) => {
    const handleDeleteMixtures = async () => {
        const deletedRows = [];
        const deletePromises = users.map(async (row) => {
            try {
                const response = await api.delete(`/customers/delete/${row.original.id}`);
                if (response.status === 200) {
                    deletedRows.push(row);
                } else {
                    console.log('Error deleting row', row.original.index);
                }
            } catch (error) {
                console.log('Error deleting row', row.original.index, error);
            }
        });

        try {
            await Promise.all(deletePromises);
        } catch (error) {
            console.log('Error deleting rows', error);
        }

        const selectedIds = deletedRows.map(row => row.index);
        updateTable(selectedIds)
        ref.current.hideModal();
        toast.success(`${selectedIds.length} Client${selectedIds.length > 1 ? 's' : ''} supprimé${selectedIds.length > 1 ? 's' : ''}`, { autoClose: 1000 });


    }

    return (
        <PortalModal className={'w-4/5 flex flex-col gap-y-4'} ref={ref}>
            <div className='flex flex-col'>
            <h1 className='card-title m-0'>Supprimer une sélection</h1>
            </div>
            <div className='flex flex-col'>
            <p>Êtes-vous sûr de vouloir supprimer les clients :</p>
            {users.length > 0 &&
                <ol className='flex flex-col'>
                    {users.map(row => <li key={row.index}>{row.original.firstname} {row.original.lastname}</li>)}
                </ol>
            }

            </div>
            <p className='text-sm text-center'>Cette action est irréversible</p>
            <div className='join join-horizontal items-center justify-center'>
                <button className='btn btn-primary join-item' onClick={() => ref.current.hideModal()}>Annuler</button>
                <button className='btn btn-error join-item' onClick={handleDeleteMixtures}>Supprimer</button>
            </div>
        </PortalModal>

    )
})

export default DeleteMultipleCustomersModal
